import { Draggable } from '@hello-pangea/dnd';
import React from 'react';
import {
    ButtonGroup,
    CardBody,
    CardFooter,
    CardSubtitle,
    CardTitle,
} from 'reactstrap';
import DragIndicator from './DragIndicator';
import moment from 'moment';
import cls from 'classnames';
import LowboyEquipmentLocationButton from './LowboyEquipmentLocationButton';

export default class LowboyEquipmentCard extends React.Component {
    render() {
        const {
            equipmentTypes,
            equipment,
            index,
            equipmentMoves,
            resourcingCounts,
        } = this.props;

        if (!equipment) {
            return null;
        }

        const equipmentMove = equipmentMoves.find(
            (em) => em.equipmentId == equipment.id
        );

        const equipmentType = equipmentTypes.find(
            (et) => equipment.equipmentTypeId == et.id
        );

        return (
            <Draggable draggableId={`eq-${equipment.id}`} index={index}>
                {(provided, snapshot) => {
                    const minimal = snapshot && snapshot.isDragging;

                    return (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={cls('card equipment-card', { minimal })}
                        >
                            <DragIndicator />
                            <CardBody>
                                <CardTitle>
                                    <div className="equipment-display">
                                        #{equipment.identifier}{' '}
                                        {equipment.description}
                                    </div>
                                </CardTitle>
                                <CardSubtitle className="mt-1 mb-1 text-muted d-flex flex-row justify-space-between align-items-start">
                                    <label>{equipmentType.description}</label>
                                </CardSubtitle>
                                <CardSubtitle>
                                    <LowboyEquipmentLocationButton
                                        {...this.props}
                                    />
                                </CardSubtitle>

                                <CardFooter>
                                    <ButtonGroup size="sm">
                                        {resourcingCounts.map((rc) => {
                                            const dayAbbreviation = moment(
                                                rc.date
                                            )
                                                .format('dd')
                                                .charAt(0);

                                            const dayOfMonth = moment(
                                                rc.date
                                            ).format('D');

                                            const active =
                                                equipmentMove &&
                                                equipmentMove.moveDates.some(
                                                    (md) =>
                                                        moment(md).isSame(
                                                            rc.date,
                                                            'day'
                                                        )
                                                );

                                            return (
                                                <span
                                                    key={`eq-${equipment.id}-d-${dayOfMonth}`}
                                                    className={cls(
                                                        'btn btn-sm btn-outline-secondary scheduledDayIndicator',
                                                        {
                                                            active,
                                                        }
                                                    )}
                                                >
                                                    {dayAbbreviation}
                                                </span>
                                            );
                                        })}
                                    </ButtonGroup>
                                </CardFooter>
                            </CardBody>
                        </div>
                    );
                }}
            </Draggable>
        );
    }
}
